<template>
  <main class="container my-5">
    <Loading v-if="btnLoading"></Loading>
    <div id="accordion" v-if="!this.btnLoading">
      <div :class="steps === 'pedido' ? 'show collapse' : 'collapse'">
        <div class="">
          <DetalhesAssinaturas
            :idAssinatura="idAssinatura"
            :idPlanoAssinatura="idPlanoAssinatura"
            :objAssinatura="objAssinatura"
            :mostrarEndereco="mostrarEndereco"
            :assinarPlano="atualizarAssinatura"
            @goToStep="goToStep"
            @carregarCobranca="carregarCobranca"
          />
        </div>
      </div>
      <div
        class=""
        v-if="
          idPlanoAssinatura &&
          objRecorrencia &&
          objRecorrencia.status !== 'REGISTRADO'
        "
      >
        <div :class="steps === 'associados' ? 'show collapse' : 'collapse'">
          <div class="">
            <StepAssociados @goToStep="goToStep"> </StepAssociados>
          </div>
        </div>
      </div>
      <div class="" v-if="mostrarEndereco">
        <div :class="steps === 'endereco' ? 'show collapse' : 'collapse'">
          <div class="">
            <StepEndereco
              v-if="steps === 'endereco'"
              :cep="cep"
              @goToStep="goToStep"
              @enderecoSalvo="enderecoSalvo"
            ></StepEndereco>
          </div>
        </div>
      </div>
      <div class="">
        <div :class="steps === 'pagamento' ? 'show collapse' : 'collapse'">
          <div class="">
            <StepPagamento
              v-if="steps === 'pagamento'"
              :idAssinatura="idAssinatura"
              :idPlanoAssinatura="idPlanoAssinatura"
              :modeloCobranca="modeloCobranca"
              @goToStep="goToStep"
            ></StepPagamento>
          </div>
        </div>
      </div>

      <div class="">
        <div :class="steps === 'boleto' ? 'show collapse' : 'collapse'">
          <div class="">
            <StepBoleto
              v-if="steps === 'boleto'"
              :idAssinatura="idAssinatura"
              :idPlanoAssinatura="idPlanoAssinatura"
              :modeloCobranca="modeloCobranca"
              @goToStep="goToStep"
            ></StepBoleto>
          </div>
        </div>
      </div>

      <div class="">
        <div :class="steps === 'pix' ? 'show collapse' : 'collapse'">
          <div class="">
            <StepPix
              v-if="steps === 'pix'"
              :idAssinatura="idAssinatura"
              :idPlanoAssinatura="idPlanoAssinatura"
              :modeloCobranca="modeloCobranca"
              @goToStep="goToStep"
            ></StepPix>
          </div>
        </div>
      </div>

      <div class="">
        <div
          :class="
            steps === 'confirmacaoPagamento' ? 'show collapse' : 'collapse'
          "
        >
          <div class="">
            <StepConfirmacaoPagamento
              v-if="steps === 'confirmacaoPagamento'"
              :idAssinatura="idAssinatura"
              :idPlanoAssinatura="idPlanoAssinatura"
              @goToStep="goToStep"
            ></StepConfirmacaoPagamento>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from "../APIService";
const apiService = new APIService();
import DetalhesAssinaturas from "../components/assinaturas/DetalhesAssinaturas";
import StepAssociados from "../components/assinaturas/StepAssociados";
import StepEndereco from "../components/assinaturas/StepEndereco";
import StepPagamento from "../components/assinaturas/StepPagamento";
import StepConfirmacaoPagamento from "../components/assinaturas/StepConfirmacaoPagamento";
import StepBoleto from "../components/assinaturas/StepBoleto.vue";
import StepPix from "../components/assinaturas/StepPix.vue";
import Loading from "@/components/Loading.vue";

export default {
  name: "DetalhesAssinatura",
  components: {
    DetalhesAssinaturas,
    StepAssociados,
    StepEndereco,
    StepPagamento,
    StepConfirmacaoPagamento,
    StepBoleto,
    StepPix,
    Loading,
  },
  data() {
    return {
      objAssinatura: null,
      objRecorrencia: null,
      idAssinatura: this.$route.params.idAssinatura,
      idPlanoAssinatura: this.$route.params.idPlanoAssinatura,
      steps: "pedido",
      cep: "",
      objPedido: null,
      loading: false,
      pedido: null,
      quantidadeParcelas: 1,
      quantidadeMaximaParcelasConfig: null,
      enderecoForm: false,
      loadingCep: false,
      cepNaoLocalizado: false,
      enderecoEntrega: {
        cep: "",
        endereco: "",
        complemento: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        pais: "",
      },
      confirmacaoPagamento: null,
      mostrarEndereco: false,
      btnLoading: false,
      modeloCobranca: null,
      atualizarAssinatura: false,
    };
  },
  mounted() {
    this.idPlanoAssinatura > 0 &&
      this.obterMinhaAssinaturaID(this.idPlanoAssinatura);
    apiService
      .dadosApp()
      .then((response) => (this.mostrarEndereco = !response.pessoa.endereco));
  },
  methods: {
    obterMinhaAssinaturaID(id) {
      if (id > 0) {
        this.btnLoading = true;
        apiService.obterMinhaAssinaturaID(id).then((response) => {
          this.objRecorrencia = response;
          this.btnLoading = false;
        });
      }
    },
    enderecoSalvo(value) {
      this.mostrarEndereco = !value;
      this.atualizarAssinatura = value;
    },
    goToStep(value) {
      this.idPlanoAssinatura = this.$route.params.idPlanoAssinatura;

      if (value === "pagamento") {
        this.obterMinhaAssinaturaID(this.$route.params.idPlanoAssinatura);
      } else if (value == "boleto") {
        this.boleto = true;
      }
      this.steps = value;
    },
    carregarCobranca(value) {
      this.modeloCobranca = value;
    },
  },
};
</script>
<style scoped lang="scss">
.pageHeader {
  background-color: #fff;
}
.title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.1rem;
}
img {
  height: 36px;
}
</style>
